<template>
  <div class="fixed" v-show="visible">
    <div class="mask" @click.stop="hide"></div>
    <div class="popup" :style="{ '--bg': bgColor, '--maxW': maxW }">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "popup",
  props: {
    bgColor: {
      type: String,
      default: "transparent",
    },
    visible: {
      type: Boolean,
      default: false,
    },
    maxW: {
      type: String,
      default: "680px",
    },
  },
  methods: {
    hide() {
      this.$emit("hide");
    },
  },
};
</script>

<style scoped>
.fixed {
  position: fixed;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 101;
}
.mask {
  position: absolute;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  left: 0;
  top: 0;
  z-index: 1;
}
.popup {
  position: absolute;
  width: 100%;
  max-width: var(--maxW);
  height: auto;
  padding: 15px;
  /* background: #fff; */
  /** 使用var()获取变量，参数就是变量名 */
  background-color: var(--bg);
  border-radius: 10px;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  z-index: 2;
}
</style>